/**
 * Lightweight CZ/SK checkout phone check (no libphonenumber on the client).
 * Accepts +420/+421/00420/00421 or a national 9-digit number.
 */
export function isValidCheckoutPhone(phone, country = "cz") {
  if (typeof phone !== "string") {
    return false;
  }

  const stripped = phone.replace(/[\s\-().]/g, "");
  if (!stripped) {
    return false;
  }

  const region = String(country).toLowerCase() === "sk" ? "sk" : "cz";
  const countryCallingCode = region === "sk" ? "421" : "420";

  let national = stripped;
  if (national.startsWith("+")) {
    national = national.slice(1);
  }
  if (national.startsWith("00")) {
    national = national.slice(2);
  }

  if (national.startsWith("420") || national.startsWith("421")) {
    national = national.slice(3);
  } else if (national.startsWith(countryCallingCode)) {
    national = national.slice(countryCallingCode.length);
  }

  if (national.startsWith("0")) {
    national = national.slice(1);
  }

  return /^\d{9}$/.test(national);
}
